import { render, staticRenderFns } from "./projectfour.vue?vue&type=template&id=0374c497&scoped=true"
import script from "./projectfour.vue?vue&type=script&lang=js"
export * from "./projectfour.vue?vue&type=script&lang=js"
import style0 from "./projectfour.vue?vue&type=style&index=0&id=0374c497&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374c497",
  null
  
)

export default component.exports